import { render, staticRenderFns } from "./ContractForm.vue?vue&type=template&id=bfc465c0&"
import script from "./ContractForm.vue?vue&type=script&lang=js&"
export * from "./ContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports